/**
 * Created by matheusmorett on 06/08/18.
 */
import React from 'react';

import './Modal.scss';
import logo from './../../assets/img/adrenalyze/adrena-me.svg';

export default class Modal extends React.Component {

  static defaultProps = {
    onBack: () => {
    },
    showBackButton: false,
    logoHeader: false
  };

  constructor(props) {
    super(props);

    this.state = {
      height: window.innerHeight
    };

    this.handleOnBack = this.handleOnBack.bind(this);
    this.resize = this.resize.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize)
  }

  resize() {
    this.setState({
      height: window.innerHeight
    });
  }

  componentDidUpdate() {
    if (this.props.open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }

  handleOnBack() {
    this.props.onBack();
  }

  render() {

    const {adventureName, requestDate, activeStep, open, children} = this.props;
    const {height} = this.state;

    return (
      <div className={"Modal " + (open && "open")} style={{
        height: height
      }}>
        {this.props.showBackButton && <span className="go-back" onClick={() => this.props.onBack()}>&#8810; Voltar</span>}
        <div className="modal-container">
          <div className="header">
            <h3><span className="text-primary">{adventureName}</span> {adventureName && requestDate && "-"} {requestDate}</h3>
          </div>
          <div className="header-step">
            <div className={'header-step-item ' + (activeStep > 0 && "header-step-item__active")}>
              <span className={"header-step__simple"}/>
              <span className={"header-step-label"}>Informações</span>
            </div>
            <div className={'header-step-item ' + (activeStep > 1 && "header-step-item__active")}>
              <span className={"header-step__simple"}>
                <div className="header-step__progress"><div className="header-step__progress-bar"/></div>
              </span>
              <span className={"header-step-label"}>Pagamento</span>
            </div>
            <div className={'header-step-item ' + (activeStep > 2 && "header-step-item__active")}>
              <span className={"header-step__simple"}>
                <div className="header-step__progress"><div className="header-step__progress-bar"/></div>
              </span>
              <span className={"header-step-label"}>Conclusão</span>
            </div>
          </div>
          {children}
        </div>
      </div>
    );
  }
}
